import React, { useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { providerItems } from 'features/slotsHistory/model/data';

import './SlotsHistoryItem.scss';

const b = block('slots-history-item-mobile');

const SlotsHistoryItem = ({ item, userId }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const { amount, date, provider, status } = item;

  const providerName = useMemo(() => {
    const name = providerItems.find(p => p?.value?.toLowerCase() === provider?.toLowerCase())?.selectedRenderElement;
    if (name) return name;
    return null;
  }, [provider]);

  console.log(status === 1);

  return (
    <div className={b()}>
      <div className={b('top')}>
        <div className={b('item')}>
          <div className={b('label')}>{locale.userId}</div>
          <div className={b('value')}>{item.userID}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.username}</div>
          <div className={b('value')}>{item.username}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.provider}</div>
          <div className={b('value')}>{provider}</div>
        </div>
      </div>
      <div className={b('bottom')}>
        <div className={b('item')}>
          <div className={b('label')}>{locale.date}</div>
          <div className={b('value')}>{dayjs(date).format('DD.MM.YY, HH:mm')}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.amount}</div>
          <div className={b('value')}>{`${Number(amount).toFixed(2)}`}</div>
        </div>
        <div className={b('item')}>
          <div className={b('label')}>{locale.type}</div>
          {status === 1 ? (
            <div className={b('outcome', { status })}>{locale.win}</div>
          ) : (
            <div className={b('outcome')}>{locale.bet}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SlotsHistoryItem;
